import Table from '../../components/ui/Table'
import EmptyState from '../../components/ui/EmptyState'
import TransactionRow from './TransactionRow'

function TransactionTable({
  transactions,
  onEdit,
  onDelete,
  onAdd,
  showBusiness = false,
}) {
  if (transactions.length === 0) {
    return (
      <EmptyState
        icon="💰"
        title="No transactions yet"
        description="Add your first transaction to start tracking"
        action={onAdd}
        actionLabel="Add Transaction"
      />
    )
  }

  return (
    <Table>
      <Table.Head>
        <Table.Row>
          <Table.Header>Date</Table.Header>
          <Table.Header>Description</Table.Header>
          {showBusiness && <Table.Header>Business</Table.Header>}
          <Table.Header>Category</Table.Header>
          <Table.Header style={{ textAlign: 'right' }}>Amount</Table.Header>
          <Table.Header style={{ width: '60px' }}></Table.Header>
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {transactions.map(transaction => (
          <TransactionRow
            key={transaction.id}
            transaction={transaction}
            onEdit={onEdit}
            onDelete={onDelete}
            showBusiness={showBusiness}
          />
        ))}
      </Table.Body>
    </Table>
  )
}

export default TransactionTable
